/* eslint-disable @typescript-eslint/naming-convention */
import {PolygonProperties, PolygonView} from '../PolygonView';
import {Rect} from '../../../../../model/Rect';
import {Container} from '../../../../../Container';
import {MoveDrawable} from '../../../../../service/tool/draw/type/MoveDrawable';
import {ElementType} from '../../../../../dataSource/constant/ElementType';
import {ElementCursor, ElementView} from '../../../../ElementView';
import {baseOfTriangle} from '@app/modules/svg/service/math/Traingle';

export class IsoscelesTrapezoidCursor extends ElementCursor {}

export interface IsoscelesTrapezoidProperties extends PolygonProperties {
  rightShapeAngle: number;
}

/*
*   0______1
*   /       \
*  /_________\
*  3          2
* */

export class IsoscelesTrapezoidView extends PolygonView implements MoveDrawable {
  public static readonly DEFAULT_RIGHT_SHAPE_ANGLE: number = 60;
  protected override _type: ElementType = ElementType.ISOSCELES_TRAPEZOID;

  public constructor(container: Container,
                     properties: IsoscelesTrapezoidProperties = {overEvent: true,globalStyle: true, rightShapeAngle: IsoscelesTrapezoidView.DEFAULT_RIGHT_SHAPE_ANGLE},
                     rect: Rect = {x: 0, y: 0, width: 1, height: 1},
                     ownerId?: string, index?: number
  ) {
    const baseSideRatio: number = baseOfTriangle(properties.rightShapeAngle, rect.height) / 2 / (rect.height || 1);
    const skewFactor: number = baseSideRatio * rect.width;

    super(container, {}, [
      /* 0 */                                                                                     /* 1 */
      {x: rect.x + skewFactor, y: rect.y},               {x: rect.width + rect.x - skewFactor, y: rect.y},
      {x: rect.width + rect.x, y: rect.height + rect.y},             {x: rect.x, y: rect.height + rect.y}
      /* 2 */                                                                                     /* 3 */
    ], ownerId, index);

    this.setProperties(properties);
  }

  public __drawSize__(rect: Rect): void {
    const baseSideRatio: number = baseOfTriangle(this.properties.rightShapeAngle, rect.height) / 2 / (rect.height || 1);
    const skewFactor: number = baseSideRatio * rect.width;

    this._points = [];
    this._points.push({ /* 0 */
      x: rect.x + skewFactor,
      y: rect.y
    });
    this._points.push({ /* 1 */
      x: rect.x + rect.width - skewFactor,
      y: rect.y
    });
    this._points.push({ /* 2 */
      x: rect.x + rect.width,
      y: rect.y + rect.height
    });
    this._points.push({ /* 3 */
      x: rect.x,
      y: rect.y + rect.height
    });

    this._rect = ElementView.calculateRect(this._points);

    this.__updateView__();
  }

  public override get properties(): IsoscelesTrapezoidProperties {
    return this._properties as IsoscelesTrapezoidProperties;
  }

  public override isComplete(): boolean {
    return this._rect.width !== 0 && this._rect.height !== 0;
  }
}
